




import Chart from "chart.js";
import { ChartOptions, DataSet } from "./graphData";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class LineChart extends Vue {
  @Prop({ default: "lines" }) public readonly id!: string;
  @Prop({ default: [] }) public readonly labels!: Array<string> | Array<Date>;
  @Prop({ default: () => [] }) public readonly data!: Array<number>;
  @Prop({ default: () => [] }) public readonly dataSet!: Array<DataSet>;

  @Prop({ default: () => Chart.defaults.line })
  @Prop({ default: () => new ChartOptions() })
  public readonly options!: ChartOptions;
  public readonly colors!: Array<string>;

  public chart: any;

  @Watch("labels", { immediate: false })
  public onPropertyChangedLabel(value: any, oldValue: any) {
    if (null !== this.labels && this.labels.length > 0) {
      this.makeChart();
    }
  }

  @Watch("dataSet", { immediate: false })
  public onPropertyChangedDataset(value: any, oldValue: any) {
    if (null !== this.labels && this.labels.length > 0) {
      this.makeChart();
    }
  }

  public mounted() {
    if (null !== this.labels && this.labels.length > 0) {
      this.makeChart();
    }
  }

  public makeChart() {
    if (this.chart) {
      this.chart.destroy();
    }
    // console.log("init", this.data);
    // console.log(this.labels);
    if (this.data.length === 0) {
      this.createChart({ datasets: this.dataSet, labels: this.labels });
    } else {
      this.createChart({
        datasets: [
          {
            data: this.data,
            defaultColor: "white",
            pointBackgroundColor: "transparent",
            pointBorderColor: "transparent",
            backgroundColor: "rgba(255,255,255,0.45)",
            borderColor: "white",
            borderWidth: 1,
          },
        ],
        labels: this.labels,
      });
    }
  }

  private createChart(chartData: object) {
    const canvas = document.getElementById(this.id) as HTMLCanvasElement;
    const chartOptions = {
      type: "line",
      data: chartData,
      options: this.options,
    };
    // console.log(chartOptions);
    this.chart = new Chart(canvas, chartOptions);
  }
}
